import { render, staticRenderFns } from "./TransferPricing.vue?vue&type=template&id=1d7a6a20"
import script from "./TransferPricing.vue?vue&type=script&lang=js"
export * from "./TransferPricing.vue?vue&type=script&lang=js"
import style0 from "./TransferPricing.vue?vue&type=style&index=0&id=1d7a6a20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports